import { render, staticRenderFns } from "./DealerAdmin.vue?vue&type=template&id=15b60951&scoped=true&lang=pug&"
import script from "./DealerAdmin.vue?vue&type=script&lang=js&"
export * from "./DealerAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DealerAdmin.vue?vue&type=style&index=0&id=15b60951&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b60951",
  null
  
)

export default component.exports